import WorkoutHeader from './WorkoutHeader';

export default WorkoutHeader;
